import styled from "styled-components";
const MyDiv = styled.div`
.select_box {
    
}
`;
export default MyDiv